// extracted by mini-css-extract-plugin
export var relativeWrapper = "NewsPost-module--relativeWrapper--2GbWt";
export var decor = "NewsPost-module--decor--iscba";
export var newsPostWrapper = "NewsPost-module--newsPostWrapper--2wvdF";
export var newsMedia = "NewsPost-module--newsMedia--5NURb";
export var newsContent = "NewsPost-module--newsContent--3j5NP";